<template>
  <div class="direct-debit-card">
    <v-row no-gutters justify="space-between">
      <img src="@/assets/images/PaymentCardLogos/bank.svg" alt="bank" class="payment-profile-img">
      <div class="text-center" v-if="isDefault!==card.id && canManage">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-icon size="14" v-bind="attrs" v-on="on" :data-test-id="`${dataTestId}__mark-as-default-icon`">settings</v-icon>
          </template>
          <v-list :data-test-id="`${dataTestId}__mark-as-default-list-item`">
            <v-list-item
              v-for="(item, index) in [{title:'Make as default'}]"
              :key="index"
              @click="()=>makeAsDefaultPayment(card.id)"
              :data-test-id="`${dataTestId}__mark-as-default-list-item-${index+1}`"
            >
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-row>
    <p class="text-left mt-3">{{card.maskedBankAccountNumber }}</p>
    <v-row no-gutters class="text-left mt-2">
      <span class="font10 truncate-line">Name: {{ card.firstName + ' ' + card.lastName }}</span>
    </v-row>
    <v-row no-gutters justify="space-between" align="center">
      <span class="font10">
        Bank Name: {{ card.bankName }}
      </span>
      <div v-if="isDefault===card.id" class="font10 card-active">
        <v-icon size="14">done</v-icon>
        <span>Active</span>
      </div>
    </v-row>
  </div>
</template>
<script>
export default {
  name: 'DirectDebit',
  props: ['card', 'isDefault', 'makeAsDefaultPayment', 'canManage', 'dataTestId'],
};
</script>
<style scoped>
p {
  margin: 0px;
}
.card-active {
  border: 1px solid #58e2c2;
  border-radius: 8px;
  padding: 1px 3px;
}
.payment-profile-img {
  width: 28px;
  aspect-ratio: 1;
}
.direct-debit-card {
  width: 200px;
}
</style>